<script>
    import f9button from "inputs/f9button.vue";
    import f9link from "inputs/f9link.vue";
    import { redirect } from "shared/Utilities/langUtilities";

    export default {
        props: {
            "menuData": Object,
            "profileLink": String,
            "headerLinks": Array
        },
        components: {
            f9button,
            f9link
        },
        data(){
            return {
                isEs: window.location.host.indexOf("es.") === 0
            };
        },
        methods: {
            getLink(link) {
                if(this.isEs) {
                    return String(link).replace("www.flyfrontier", "es.flyfrontier");
                }
                return link;
            },
            redirectLanguage() {
                redirect(this.isEs ? "www" : "es");
            }
        }
    }
</script>

<template>
    <div class="nav-mobile">
        <div v-if="headerLinks.length" class="headerlink-container">
            <div class="nav-section-head row-cb">
                Travel Tales
                <!--mp_global_switch_begins-->
                <f9link id="MobileSpanishToggler" ref="esLink" v-show="!isEs" class="es-link langLink" data-href="es.flyfrontier.com" data-lang="es" mporgnav="" @click="redirectLanguage" nostyle>
                    Español
                </f9link>
                <!--mp_global_switch_ends-->
            </div>
            <div class="nav-section">
                 <f9link v-for="headerLink in headerLinks" :new-window="headerLink.newWindow" :key="headerLink.id" 
                  nostyle  :href="getLink(headerLink.link)"  class="a nav-section-sub-head row-cb" v-html="headerLink.text"></f9link>
                 <f9link :new-window="false" nostyle  :href="getLink('https://www.flyfrontier.com')"  class="a nav-section-sub-head row-cb" v-html="'FLYFRONTIER.COM'"> </f9link>
            </div>
           
        </div>
        <div v-else>
            <div class="nav-section-head row-cb">
                <f9link :href="getLink(menuData.travel.link.link)" :new-window="menuData.travel.link.newWindow" nostyle v-html="menuData.travel.name"></f9link>
                <!--mp_global_switch_begins-->
                <f9link id="MobileSpanishToggler" ref="esLink" v-show="!isEs" class="es-link langLink" data-href="es.flyfrontier.com" data-lang="es" mporgnav="" @click="redirectLanguage" nostyle>
                    Español
                </f9link>
                <f9link id="MobileEnglishToggler" ref="enLink" v-show="isEs" class="en-link langLink" data-href="www.flyfrontier.com" data-lang="en" @click="redirectLanguage" nostyle>
                    English
                </f9link>
                <!--mp_global_switch_ends-->
            </div>
            <div class="nav-sections">
                <div v-for="(section, index) in menuData.travel.sections" class="nav-section" :key="section.id">
                    <f9button nostyle class="nav-section-sub-head row-cb" :aria-expanded="section.visible" @click="section.visible = !section.visible"
                        :class="{ expanded: !!section.visible, last: index === menuData.travel.sections.length - 1 }">
                        <span v-html="section.name"></span>
                        <img src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/downUpArrow.svg" class="down-arrow" alt="">
                    </f9button>
                    <div class="nav-section-items" v-show="section.visible">
                        <f9link v-for="link in section.links" :new-window="link.newWindow" :key="link.id" 
                            nostyle :href="getLink(link.link)" class="nav-section-item horizontal center left content-link" v-html="link.caption">
                        </f9link>
                    </div>
                </div>
            </div>
            <div class="nav-section-head row-cb">
                <f9link :href="getLink(menuData.deals.link.link)" :new-window="menuData.deals.link.newWindow" nostyle v-html="menuData.deals.name"></f9link>
            </div>
            <div class="nav-section">
                <f9link v-for="(link, index) in menuData.deals.section.links" :new-window="link.newWindow" :key="link.id" nostyle :href="link.link" 
                    class="nav-section-item no-parent horizontal center left" :class="{ highlighted: index === 0 }" v-html="link.caption">
                </f9link>
            </div>
            <div class="nav-section-head row-cb">
                <f9link :href="getLink(profileLink)" nostyle class="horizontal center left content-link">                    
                    <i v-html="menuData.myFrontier.name"></i>
                    &nbsp;Miles
                    <span class="sm">sm</span>
                </f9link>
            </div>
            <div class="nav-section">
                <f9link v-for="link in menuData.myFrontier.leftSection.links" :new-window="link.newWindow" 
                    :key="link.id" nostyle :href="getLink(link.link)" class="nav-section-item no-parent horizontal center left content-link" v-html="link.caption">
                </f9link>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    @nav-link-height: 38px;

    .nav-mobile {
        .row-cb {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .row-bb {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            justify-content: space-between;
        }

        .down-arrow {
            transition: transform 300ms ease-in-out;
            height: 8px;
        }

        .expanded {
            .down-arrow {
                .rotate(180deg);
            }
        }
            
        .nav-section-head {
            height: @nav-link-height;
            background-color: rgba(232, 232, 232, .5);
            font-size: 14px;
            color: @frontier-green;
            text-transform: uppercase;
            font-weight: 600;
            padding-left: 20px;
            padding-right: 11px;

            .my-img {
                display: inline-block;
                margin-top: 7px;
                width: 24px;
                height: 19px;
                background-image: url(https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/mysvg_green.svg)
            }

            .es-link, 
            .en-link {
                font-size: 10px;
                font-weight: 400;
                text-transform: capitalize;
                text-decoration: none;
            }
        }

        .nav-section {
            padding: 0 20px;

            .nav-section-sub-head {
                font-size: 12px;
                font-weight: 600;
                color: @frontier-gray-xxdark;
                height: @nav-link-height;

                &:not(.last),
                &.expanded {
                    border-bottom: 1px solid @frontier-gray-xxlighter;
                }
            }
            
            .nav-section-item {
                height: @nav-link-height;
                font-size: 12px;
                font-weight: 400;
                color: @ibe-text--light-bluegray;

                &.no-parent:not(:last-of-type) {
                    border-bottom: 1px solid @frontier-gray-xxlighter;
                }

                &.highlighted {
                    color: @ibe-text--red;
                }
            }

            .content-link {
                & @{deep} * {
                    padding-right: 4px;
                }
            }
        }

        .sm {
            font-size: 7px;
            margin-bottom: 5px;
        }
    }
</style>